import Marquee from "react-fast-marquee";

const items = [
  "bismillah",
  "make your niyyah",
  "renew the passports",
  "sell the minivan",
  "choose your country",
  "one-way ticket",
  "the adhan is waiting",
  "pack light, akhirah heavy",
];

export const MarqueeRibbon = ({ dark = false }) => (
  <div
    data-testid="editorial-marquee"
    className={`py-6 border-y overflow-hidden ${
      dark ? "bg-pine-ink border-cream/10" : "bg-blush-deep border-petal/15"
    }`}
  >
    <Marquee speed={28} gradient={false} pauseOnHover>
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span
            className={`font-serif italic text-2xl lg:text-3xl px-10 ${
              dark ? "text-cream/70" : "text-pine/80"
            }`}
          >
            {item}
          </span>
          <span className="text-petal text-sm">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
